var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAverageScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18023_6994)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4.00002C1.7919 0.00254983 0.00254983 1.7919 0 4.00002V20C0.00254983 22.2081 1.7919 23.9975 4.00002 24H20C22.2081 23.9974 23.9975 22.2081 24 20V4.00002C23.9974 1.7919 22.2081 0.00254983 20 0ZM8 16C8 16.5523 7.55229 17 6.99999 17C6.4477 17 5.99999 16.5523 5.99999 16V12C5.99999 11.4477 6.4477 11 6.99999 11C7.55229 11 8 11.4477 8 12V16ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V6.99999C11 6.4477 11.4477 5.99999 12 5.99999C12.5523 5.99999 13 6.4477 13 6.99999V16ZM18 16C18 16.5523 17.5523 17 17 17C16.4477 17 16 16.5523 16 16V10C16 9.44772 16.4477 9 17 9C17.5523 9 18 9.44772 18 10V16Z",
    fill: "#F59E0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18023_6994"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAverageScore);
export default __webpack_public_path__ + "static/media/ic_average_score.d2eaea25a9d36decd733483d948529fa.svg";
export { ForwardRef as ReactComponent };